import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './NotFound.module.css';

const NotFound = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <h1 className={styles.title}>404</h1>
                <p className={styles.description}>
                    The page you are looking for doesn't exist or has been moved. Please go back to the homepage.
                </p>
                <div 
                    className={styles.button}
                    onClick={handleGoHome}
                >
                    <span className={styles.buttonText}>Go back home</span>
                </div>
            </div>
        </div>
    );
};

export default NotFound;